import getCookie from '../../../../../partials/cookie';

function Form(props) {
    let csrftoken = getCookie('csrftoken')
        return(
            <form method="post" action="/platnosc/utworz/" encType="multipart/form-data" className="form-horizontal" preventdefault='true'>
                <input type="hidden" name="csrfmiddlewaretoken" value={csrftoken}autoComplete="off"></input>
                <div className="form-group">
                    <label className="control-label col-sm-2 col-lg-2" htmlFor="id_email">Adres mailowy klienta</label>
                    <div className="col-sm-10 col-lg-10">
                        <input type="email" name="email" maxLength="392" className="form-control" required id="id_email" />
                    </div>
                </div>
                <div className="form-group">
                    <label className="control-label col-sm-2 col-lg-2" htmlFor="id_description">Opis transakcji</label>
                    <div className="col-sm-10 col-lg-10">
                        <textarea name="description" className="form-control" id="id_description" cols="40" rows="10" required></textarea>
                    </div>
                </div>
                <div className="form-group">
                    <label className="control-label col-sm-2 col-lg-2" htmlFor="id_price">Oczekiwana wpłata</label>
                    <div className="col-sm-10 col-lg-10">
                        <input type="number" name="price" step="0.01" className="form-control" required id="id_price" />
                    </div>
                </div>
                <div className="form-group">
                    <label className="control-label col-sm-2 col-lg-2" htmlFor="id_renewal_time">Okres cyklicznego pobierania płatności</label>
                    <div className="col-sm-10 col-lg-10">
                        <select name="renewal_time" className="form-control" id="id_renewal_time" defaultValue='0' >
                            <option value>----------</option>
                            <option value="0" >Brak</option>
                            <option value="1">Miesięczny</option>
                            <option value="2">Roczny</option>
                        </select>
                    </div>
                </div>
                <div className="form-group">
                     <label className="control-label col-sm-2 col-lg-2" htmlFor="id_attachment">Dodaj załącznik(i)</label>
                     <div className="col-sm-10 col-lg-10">
                         <input type="file" name="attachment" multiple id="id_attachment" />
                     </div>
                </div>
                
                    <div className="form-actions">
                        <button className="btn btn-success btn-lg pull-right" type="submit">Wyślij</button>
                    </div>
                    <div className="clearfix"></div>
                </form>
        )
}

export default Form;